import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { ComplexValue } from 'ui';
import get from 'lodash/get';

export const tileHeaderPrimaryKey = (state: any, uiEngineProps: ConnectedComponentProps) => {
  const props = get(uiEngineProps, 'componentDescriptor.properties');

  if(!props.showPrimaryKey) {
    return {};
  }
  const primaryKey = get(uiEngineProps, 'resolveContext.primaryKey') as ComplexValue<number>;
  return {
    headerTitle: '#'+primaryKey.value
  };
};

export const tileHeaderPrimaryKeyWithReportKeyLabel = (state: any, uiEngineProps:any) => {
  const rtnProps = tileHeaderPrimaryKey(state, uiEngineProps);
  const props = get(uiEngineProps, 'componentDescriptor.properties');
  if (rtnProps.headerTitle && props.showReportKeyLabel) {
    rtnProps.headerTitle = `${props.reportKeyLabel} ${rtnProps.headerTitle}`;
  }
  return rtnProps;
};
